/*
* Important!!!
* In this file I use random as key now.
* But in fact,if we get separate body.json and render it one by one. Due to react-diff algorithm,use random key will cause performance down.
* if possible please change the random key to unique key,that from key can reflect different data, that we can render bodyJson one by one.
* after change key you can open the if else in fetchBodyDataOneByOne function at asyncStateAction.tsx
*/
import React, { PureComponent } from 'react';
import _ from 'lodash';
import DrawingTemplate from './drawingTemplate';
import HyperlinkTemplate from './hyperlinkTemplate';
import StyleTransfrom from '../utils/general/styleTransform';
import BracketTemplate from './bracketTemplate';
import FootnoteTemplate from './footnoteTemplate';
import CitiListTemplate from './citiListTemplate';
import CitiTableTemplate from './citiTableTemplate';
import ParagraphTemplate from './paragraphTemplate';
import DivContainerTemplate from './divContainerTemplate';
import VideoTemplate from './videoTemplate';
import TabTemplate from './tabTemplate';
import FinancialsLevel1TabsTemplate from './financialsLevel1TabsTemplate';
import FinancialsLevel2TabsTemplate from './financialsLevel2TabsTemplate';
import shortid from 'shortid';
import wingdingsForeground from '../../style/img/wingdings-foreground.png';
import RelatedReportSection from './relatedReportSection';
import { isBase64Valid, buildAdaAltText } from '../utils/general/general';
import ErrorBoundary from '../utils/api/errorBoundary';

interface IDomTemplateProps {
    sourceM: any;
    dataStringM: string;
    classNameM: string;
    isFigure?: boolean;
    altText?: any;
    showOriginalText?: boolean;
}

class DomTemplate extends PureComponent<IDomTemplateProps, any> {

    public containsMath: boolean;
    public inParagraph: boolean;

    constructor(props: IDomTemplateProps) {
        super(props);
        this.containsMath = false;
        this.inParagraph = true;
        this.state = {

        };
    }
    /*
    * The function returns a template according to the given type.
    *
    * @templateClass A string of the type of the template to return.
    * @dataString The path of the component in the model of the scope.
    */
    public getTemplateByType = (templateClass: string, dataString: any) => {
        const altText = this.props.altText;
        const templateMappings: any = {
            divContainer: <DivContainerTemplate source={dataString} key={shortid.generate()} />,
            paragraph: <ParagraphTemplate source={dataString} key={shortid.generate()} />,
            run: '<run source="dataString"></run>',
            brlineBreaking: '<lineBreaking source="dataString"></lineBreaking>',
            drawing: <DrawingTemplate altText={altText} source={dataString} key={shortid.generate()} isFigure={this.props.isFigure} />,
            hyperlink: <ErrorBoundary><HyperlinkTemplate source={dataString} key={shortid.generate()} /></ErrorBoundary>,
            table: <CitiTableTemplate source={dataString} key={shortid.generate()} />,
            ol: <CitiListTemplate type={"ol"} source={dataString} mainSource={""} elementParent={""} key={shortid.generate()} showOriginalText={this.props.showOriginalText}/>,
            ul: <CitiListTemplate type={"ul"} source={dataString} mainSource={""} elementParent={""} key={shortid.generate()} showOriginalText={this.props.showOriginalText}/>,
            video: <VideoTemplate source={dataString} key={shortid.generate()} />,
            financialsLevel1Tabs: <FinancialsLevel1TabsTemplate source={dataString} key={shortid.generate()} />,
            financialsLevel2Tabs: <FinancialsLevel2TabsTemplate source={dataString} key={shortid.generate()} />,
            tabs: '<div tabs source="dataString"></div>',
            tab: <TabTemplate source={dataString} key={shortid.generate()} />,
            rl: '<div research-list source="dataString"></div>',
            carousel: '<div carousel source="dataString"></div>',
        };
        if (templateMappings.hasOwnProperty(templateClass)) {
            let template = templateMappings[templateClass];
            if (typeof (template) === "string") {
                template = template.replace('dataString', dataString);
            }
            return template;
        }
        return '';
    }

    /*
    * The function returns a template according to the class of the given data object.
    *
    * @data An object of the model of the component.
    * @dataString The path of the component in the model of the scope.
    */
    public getTemplate = (data: any, dataString: any) => {
        const classKey = 'class';
        if (!_.isUndefined(data) && !_.isUndefined(data[classKey])) {
            return this.getTemplateByType(data[classKey], dataString);
        }
        return '';
    }

    /*
    * The function returns a template for Array.
    *
    * @data An object of the model of the component.
    * @dataString The path of the component in the model of the scope.
    */
    public getArrayTemplate = (data: any, dataString: any, additionalClasses: string) => {
        const arrayTemplate: Array<any> = [];
        for (let i = 0; i < data.length; i++) {
            const ele = data[i];
            arrayTemplate.push(this.getRawTemplate(ele, dataString + '[' + i + ']', additionalClasses || ' '));
        }
        return arrayTemplate;
    }

    /*
    * The function returns a template for Slide.
    *
    * @data An object of the model of the component.
    * @dataString The path of the component in the model of the scope.
    */
    public getSlideTemplate = (data: any, dataString: any, additionalClasses: string) => {
        const top = 'top:' + Math.ceil(data.offsite_y) + 'pt;';
        const left = 'left:' + Math.ceil(data.offsite_x) + 'pt;';
        const width = 'width:' + Math.ceil(data.width) + 'pt;';
        const height = 'height:' + Math.ceil(data.height) + 'pt;';

        let styleProps = '';
        let styleClass = '';
        if (!_.isUndefined(data.format) && !_.isUndefined(data.format.style)) {
            styleProps = data.format.style;
        }

        if (!_.isUndefined(data.format) && !_.isUndefined(data.format['class'])) {
            styleClass = data.format['class'];
        }

        const extraSmallImageStyle = "font-size:0;line-height:0;";
        let isDrawingShape = false;
        if (data.data && data.data[0]["class"] == "drawing") {
            isDrawingShape = true;
        }
        const styleString = top + left + width + height + styleProps + (isDrawingShape ? extraSmallImageStyle : '');

        const sharpContent = this.getArrayTemplate(data.data, dataString + ".data", additionalClasses);
        let slideTemplate = <div key={shortid.generate()} className={data["class"] + ' ' + styleClass} style={StyleTransfrom(styleString)}>
            {sharpContent}
        </div>;
        if (styleClass.indexOf('slides_valign_middle') >= 0) {
            slideTemplate = <div key={shortid.generate()} className={data["class"] + ' ' + styleClass} style={StyleTransfrom(styleString)}>
                <div className={"slides_valign_middle_child"}>
                    {sharpContent}
                </div>
            </div>;
        }
        return slideTemplate;
    }

    /*
    * The function returns the template for the component, based on the 'class' property of the given data object.
    * Some components have templates as a directive, and some have the actual final HTML (the commonly used ones).
    *
    * @data An object of the model of the component.
    * @dataString The path of the component in the model of the scope.
    * @additionalClasses A string of additional classes for the component.
	*/
    public getRawTemplate = (data: any, dataString: any, additionalClasses: string) => {
        if (typeof (dataString) == "string" && dataString !== "headerTitle") {
            dataString = data;  // Important!!! because react haven't angularjs scope inheritance, so we should active assignment data!
        }
        if (!_.isNull(data) && !_.isUndefined(data) && !_.isUndefined(data['class'])) {
            if (data['class'] === "run") {
                return this.getRunTemplate(data, dataString, additionalClasses);
            } else if (data['class'] === "footnoteRun") {
                return this.getFootnoteRunTemplate(data, dataString, additionalClasses);
            } else if (dataString === "headerTitle") {
                return this.getHeaderTemplate(data, dataString, additionalClasses);
            } else if (data['class'] === "paragraph") {
                return this.getParagraphTemplate(data, dataString, additionalClasses);
            } else if (data['class'] === "divContainer") {
                return this.getDivTemplate(data, dataString, additionalClasses);
            } else if (data['class'] === "lineBreaking") {
                return this.getLineBreakingTemplate(data, dataString, additionalClasses);
            } else if (data['class'] === "cell") {
                return this.getDivTemplate(data, dataString, additionalClasses);
            } else if (data['class'] === "caption") {
                return this.getCaptionTemplate(data, dataString, additionalClasses);
            } else if (data['class'] === "internalLink") {
                return this.getTOCLinkTemplate(data);
            } else if (data['class'] === "fpbullet") {
                return this.getFPBulletTemplate(data, dataString, additionalClasses);
            } else if (data['class'] === "block") {
                return this.getDivTemplate(data, dataString, additionalClasses);
            } else if (data['class'] === 'hyperlink') {
                if (data['linkType'] === 'document_html' || data['linkType'] === 'document_pdf') {
                    return this.getHyperLinkTemplateBasedOnEntitlement(data, dataString, additionalClasses);
                } else {
                    return this.getHyperLinkTemplateNormal(data, dataString, additionalClasses);
                }
            } else if (data['class'] === "slideShape") {
                return this.getSlideTemplate(data, dataString, additionalClasses);
            } else {
                return this.getTemplate(data, dataString);
            }
        }

        if (!_.isUndefined(data) && (data instanceof Array)) {
            return this.getArrayTemplate(data, dataString, additionalClasses);
        }

        return '';
    }

    public getHyperLinkTemplateBasedOnEntitlement = (data: any, dataString: any, additionalClasses: string) => {
        const linkType = data["linkType"];
        if (linkType == 'document_html' && !window.HTML_RENDITION.initialData.isEntitled('CHILD_HTML_LINK')) { //  && !entitlementService.isEntitled('CHILD_HTML_LINK')
            data["class"] = "run";
            return this.getRunTemplate(data, dataString, additionalClasses);
        } else if (linkType == 'document_pdf' && !window.HTML_RENDITION.initialData.isEntitled('CHILD_PDF_LINK')) { // && !entitlementService.isEntitled('CHILD_PDF_LINK')
            data.class = "run";
            return this.getRunTemplate(data, dataString, additionalClasses);
        }
        return this.getTemplate(data, dataString);
    }

    public getHyperLinkTemplateNormal = (data: any, dataString: any, additionalClasses: string) => {
        const linkType = data.linkType;
        const template: Array<any> = [];
        if (linkType) {
            template.push(<ErrorBoundary><HyperlinkTemplate source={data} key={shortid.generate()} hyperLinkClassName={additionalClasses} /></ErrorBoundary>);
        }
        return template;
    }

    public getLineBreakingTemplate = (source: any, dataString: any, additionalClasses: string) => {
        return <br />;
    }

    /*
    * The function creates the actual HTML for a run component.
    */
    public getRunTemplate = (source: any, dataString: any, additionalClasses: string) => {
        if (source.isDataTable === true) {
            return this.getDataTableTemplate(source);
        }
        let styleStringJSX = "";

        if (source.format && !_.isUndefined(source.format.style) && source.format.style !== "") {
            styleStringJSX = source.format.style;
        }

        if (source.format && !_.isUndefined(source.format.class) && source.format.class !== "") {
            additionalClasses += ' ' + source.format.class + ' ';
        }

        const classStringJSX = 'x-rsch-run ' + (additionalClasses || '');

        const tooltipString = '';
        // if (!_.isUndefined(source.tooltip))
            // tooltipString = ' tooltip-html-unsafe="'+HTML_RENDITION.escapeHTML(source.tooltip)+'" '+this.tooltipPlacementRight+' tooltip-animation="false"';

        const template = [];

        if (source.text.trim().toUpperCase() == 'APPENDIX A-1' && window.HTML_RENDITION.initialData.isFAVE) {
            // hide the text: "Appendix A-1" at the end of the footer.json
            return;
        }
        if (source.text && source.text.indexOf("<math>") >= 0) {
            template.push(<span className={classStringJSX} style={StyleTransfrom(styleStringJSX)} key={shortid.generate()}>
             <span className="Container" dangerouslySetInnerHTML={{ __html: this.getMathTemplate(source.text) }}></span>
            </span>);

            // type set equation no more than 1 time in 0.2 second
            if (typeof(window.MathJax) != "undefined" && window.HTML_RENDITION.mathjax_ready_to_typeset) {
                window.HTML_RENDITION.mathjax_ready_to_typeset = false;
                setTimeout(() => {
                        window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
                        window.HTML_RENDITION.mathjax_ready_to_typeset = true;
                },500 );
            }
            if (this.inParagraph) {
                this.containsMath = true;
            }
        } else {
            // Important!!! in here We can add more if else logic to judge class and return a react components.
            // if (classStringJSX.indexOf('Hyperlink') >= 0) {
            //     template.push(<HyperlinkTemplate source={source} key={shortid.generate()} />);
            // }
            if (classStringJSX.indexOf('related-report-section') >= 0) {
                let relatedReportIndex = '';
                if (window.HTML_RENDITION.initialData.isFAVE && classStringJSX.indexOf('related_Report_Section_') >= 0){
                    const classes = classStringJSX.trim().split(' ');
                    if (classes && classes.length){
                        for (let i = 0; i < classes.length; i++){
                            relatedReportIndex = _.trim(classes[i]);
                            if (relatedReportIndex && relatedReportIndex.indexOf('related_Report_Section_') >= 0){
                                break;
                            }
                        }
                    }
                } else {
                    const nonFaveClasses = classStringJSX.toLowerCase().trim().split(' ');
                    if (nonFaveClasses && nonFaveClasses.length){
                        for (let i = 0; i < nonFaveClasses.length; i++){
                            relatedReportIndex = _.trim(nonFaveClasses[i]);
                            if (relatedReportIndex && Number(relatedReportIndex)){
                                break;
                            }
                        }
                    }
                }
                template.push(
                    <ErrorBoundary>
                        <RelatedReportSection classStringJSX={source.format.class} key={shortid.generate()} relatedReportIndex={relatedReportIndex} />
                    </ErrorBoundary>
                );
            } else {
                const premiumProductFilter = (classStringJSX.indexOf("CIRBrandedSeries") > -1 && classStringJSX.indexOf("story-branding ") > -1);
                const compediumProduct = (window.HTML_RENDITION.initialData.productCode === 'Compendium' && window.HTML_RENDITION.initialData.productType === 'compendium');
                if (compediumProduct && premiumProductFilter && source.text) {
                    source.text = source.text.replace(/,Premium Product/g,'');
                    source.text = source.text.replace(/Premium Product/g,'');
                }
                source.num && (template.push(<div className="string_num_container"><span>{source.num}</span></div>));
                if (/<[a-z/][\s\S]*>/i.test(source.text)) {
                    if (!this.props.showOriginalText){
                        template.push(<span className={classStringJSX} style={StyleTransfrom(styleStringJSX)} key={shortid.generate()} dangerouslySetInnerHTML={{ __html: source.text }} />);
                    } else {
                        template.push(<span className={classStringJSX} style={StyleTransfrom(styleStringJSX)} key={shortid.generate()}>{source.text}</span>);
                    }
                } else {
                     // Important!!! source.text use old rendition logic HTML_RENDITION.escapeHTML(source.text) will cause the blank space sometimes show with &nbsp, So remove this function!!!
                    template.push(<span className={classStringJSX} style={StyleTransfrom(styleStringJSX)} key={shortid.generate()}>{source.text}</span>); // tooltipString
                }
            }
        }
        if (source.existBeforeTextBr) {
            template.unshift(<br />);
        }
        if (source.existAfterTextBr) {
            template.push(<br />);
        }
        return template;
    }

    public getMathTemplate = (data: any):string => {
        let returnVal = "";
        const mathStartIndex = data.indexOf("<math>");
        let mathEndIndex = data.indexOf("</math>");
        if (mathStartIndex < 0 || mathEndIndex < 0) {
            return _.escape(data);
        }
        mathEndIndex += 6;
        if (mathStartIndex > 0) {
            returnVal += _.escape(data.substr(0, mathStartIndex));
        }
        returnVal += data.substr(mathStartIndex, mathEndIndex - mathStartIndex + 1);
        if (data.length > mathEndIndex + 1) {
            returnVal += this.getMathTemplate(data.substr(mathEndIndex + 1));
        }
        return returnVal;
    }

    /*
    * The function creates the actual HTML for a run component.
    */
    public getFootnoteRunTemplate = (source: any, dataString: any, additionalClasses: string) => {
        return <FootnoteTemplate key={shortid.generate()} source={dataString} />;
    }

    /*
    * The function creates the actual HTML for a paragraph component.
    */
    public getParagraphTemplate = (source: any, dataString: any, additionalClasses: string) => {
        return this.buildParagraph(source, dataString, additionalClasses);
    }

    /*
    * The function creates the actual HTML for a header component.
    */
    public getHeaderTemplate = (source: any, dataString: any, additionalClasses: string) => {
        return this.buildHeader(source, dataString, additionalClasses);
    }

    public buildHeader = (source: any, dataString: any, additionalClasses: string) => {
        if (_.isUndefined(source)) {
            return;
        }

        // The actual rows of the components inside the header.
        const paragraphBody = this.buildHeaderBody(source, dataString, additionalClasses);

        const attribute = "";
        const classes = "paragraphWrapper";
        const resultingElement = [];

        resultingElement.push(paragraphBody);

        return resultingElement;
    }

   // The function builds the rows of components inside the paragraph.
    public buildHeaderBody = (source: any, dataString: any, additionalClasses: string) => {
        this.inParagraph = true;
        let isChildParagraph = false;

        const allComponents: Array<any> = [];

        let paragraphDefaultStyle = "x-rsch-paragraph";

        let docStyle = "";

        if (!_.isUndefined(source.format)) {
            docStyle = source.format.class || "";
        }

        if (!_.isUndefined(docStyle) && (docStyle.indexOf('Heading') === 0)) {
            paragraphDefaultStyle = "x-rsch-paragraph-heading";
        }

        let dataIndex = 0;
        const that = this;
        source.data?.forEach(function (data: any, index: number, array: []) {
            if (data) {
                if (data?.class === "paragraph") {
                    isChildParagraph = true;
                }
                const templateElement = that.getRawTemplate(data, dataString + ".data[" + dataIndex + "]", ((!_.isUndefined(source.format) && source.format.class == 'citistake-container') ? '' : docStyle) + ' ' + (additionalClasses || ' '));

                const componentElement = templateElement;

                allComponents.push(componentElement);
            }
            dataIndex++;
        });
        let classAttrValue = paragraphDefaultStyle + ' ' + docStyle + ' ' + (additionalClasses || ' ') + ' ';
        classAttrValue += allComponents.length ? "paragraph-with-content" : "empty-paragraph";

        let styleAttrJSX = {};
        if (source.format && source.format.style) {
            styleAttrJSX = source.format.style;
        }

        let pTemplate;
        if (isChildParagraph && docStyle.indexOf("opinionPoll") > -1) {
            // To handle Roundup Opinion poll
            pTemplate = allComponents;
        } else {
            pTemplate = <h1 className={classAttrValue} style={StyleTransfrom(styleAttrJSX)} key={new Date().getTime()}>{allComponents}</h1>;
        }

        this.containsMath = false;
        this.inParagraph = false;

        return pTemplate;
    }
    public buildParagraph = (source: any, dataString: any, additionalClasses: string) => {
        if (_.isUndefined(source)) {
            return;
        }

        // The actual rows of the components inside the paragraph.
        const paragraphBody = this.buildParagraphBody(source, dataString, additionalClasses);

        const attribute = "";
        const classes = "paragraphWrapper";
        const resultingElement = [];

        resultingElement.push(paragraphBody);

        return resultingElement;
    }

    // The function builds the rows of components inside the paragraph.
    public buildParagraphBody = (source: any, dataString: any, additionalClasses: string) => {
        this.inParagraph = true;
        let isChildParagraph = false;

        const allComponents: Array<any> = [];

        let paragraphDefaultStyle = "x-rsch-paragraph";

        let docStyle = "";

        if (dataString && dataString.format && dataString.format.class && dataString.data && dataString.data.length > 0) {
            if (dataString.format.class == 'CIRCaption'){
                let caption = '';
                dataString.data.forEach((item : any) => {
                    if (item && item.text){
                        caption += item.text;
                    }
                });
                if (caption.startsWith('Figure') === true){
                    if (!window.HTML_RENDITION.currentFigureCaptions){
                        window.HTML_RENDITION.currentFigureCaptions = [];
                    }
                    window.HTML_RENDITION.currentFigureCaptions.push(caption);

                    if (!window.HTML_RENDITION.lastDrawingTemplates){
                        window.HTML_RENDITION.lastDrawingTemplates = [];
                    }
                }
            } else if (dataString.format.class == 'CIRSourceNote'){
                const figureSource = dataString.data[0].text;
                if (window.HTML_RENDITION.lastDrawingTemplates && window.HTML_RENDITION.lastDrawingTemplates.length > 0 &&
                    window.HTML_RENDITION.currentFigureCaptions && window.HTML_RENDITION.currentFigureCaptions.length > 0 &&
                    window.HTML_RENDITION.lastDrawingTemplates.length == window.HTML_RENDITION.currentFigureCaptions.length){
                    const caption = window.HTML_RENDITION.currentFigureCaptions.shift();
                    const lastDrawingTemplate = window.HTML_RENDITION.lastDrawingTemplates.shift();
                    lastDrawingTemplate.altTextStr = buildAdaAltText(caption, figureSource);
                } else {
                    if (window.HTML_RENDITION.currentFigureCaptions && window.HTML_RENDITION.lastDrawingTemplates){
                        const caption = window.HTML_RENDITION.currentFigureCaptions.shift();
                        window.HTML_RENDITION.lastDrawingTemplates.forEach(function (lastDrawingTemplate : any){
                            lastDrawingTemplate.altTextStr = buildAdaAltText(caption, figureSource);
                        });
                        window.HTML_RENDITION.lastDrawingTemplates = [];
                    }
                }
            }
        }

        if (!_.isUndefined(source.format)) {
            docStyle = source.format.class || "";
            // docStyle = docStyle.replace(new RegExp(" ", "g"),"");
        }

        if (!_.isUndefined(docStyle) && (docStyle.indexOf('Heading') === 0)) {
            paragraphDefaultStyle = "x-rsch-paragraph-heading";
        }

        let dataIndex = 0;
        const that = this;
        source.data.forEach(function (data: any, index: number, array: []) {
            if (data.class === "paragraph") {
                isChildParagraph = true;
            }
            const templateElement = that.getRawTemplate(data, dataString + ".data[" + dataIndex + "]", ((!_.isUndefined(source.format) && source.format.class == 'citistake-container') ? '' : docStyle) + ' ' + (additionalClasses || ' '));

            const componentElement = templateElement;

            allComponents.push(componentElement);
            dataIndex++;
        });
        let classAttrValue = paragraphDefaultStyle + ' ' + docStyle + ' ' + (additionalClasses || ' ') + ' ';
        classAttrValue += allComponents.length ? "paragraph-with-content" : "empty-paragraph";

        let styleAttrJSX = {};
        if (source.format && source.format.style) {
            styleAttrJSX = source.format.style;
        }
        // if (this.containsMath) {
        //     var words = allComponents.split('>');
        //     var newWords = new Array();
        //     for (var wordIndex in words) {
        //         var word = words[wordIndex];
        //         word = word.substr(0, word.indexOf("<")).replace(/\s\s/g, " &nbsp;") + word.substr(word.indexOf("<"));
        //         newWords.push(word);
        //     }
        //     allComponents = newWords.join(">");
        // }

        let role: any;
        let ariaLevel: any;
        const levelTwoHeadingIndicator =
            (classAttrValue.indexOf("CIRFPBulletBold") > -1 && classAttrValue.indexOf("citistake ") > -1) ||
            (classAttrValue.indexOf("CIRChapter") > -1 && classAttrValue.indexOf("body_sec") > -1 && classAttrValue.indexOf("paragraph-with-content") > -1) ||
            (classAttrValue.indexOf("Heading1") > -1 && classAttrValue.indexOf("x-rsch-paragraph-heading") > -1);
        const levelThreeHeadingIndicator =
            (classAttrValue.indexOf("Heading2") > -1 && classAttrValue.indexOf("body_sec") > -1) ||
            (classAttrValue.indexOf("Heading3") > -1 && classAttrValue.indexOf("body_sec") > -1) ||
            (classAttrValue.indexOf("x-rsch-paragraph-heading") > -1 && classAttrValue.indexOf("Heading2") > -1);

        const hCls = source.data[source.data.length - 1]?.class;

        if (levelTwoHeadingIndicator && hCls && hCls == 'run') {
            // level-2 heading
            role = "heading";
            ariaLevel = 2;
        }

        if (levelThreeHeadingIndicator && hCls && hCls == 'run') {
            // level-3 heading
            role = "heading";
            ariaLevel = 3;
        }

        let pTemplate;
        if (isChildParagraph && docStyle.indexOf("opinionPoll") > -1) {
            // To handle Roundup Opinion poll
            pTemplate = allComponents;
        } else {
            pTemplate = <p role={role} aria-level={ariaLevel} className={classAttrValue} style={StyleTransfrom(styleAttrJSX)} key={new Date().getTime()}>{allComponents}</p>;
        }

        /*if(classAttrValue.indexOf('CIRTextBullet')!=-1
                && classAttrValue.indexOf('paragraph-with-content')!=-1) {
            pTemplate = '<li className="x-bullet"></li>'+pTemplate;
        }*/

        this.containsMath = false;
        this.inParagraph = false;

        return pTemplate;
    }

    /*
    * The function creates the actual HTML for a cell component.
    */
    public getDivTemplate = (source: any, dataString: any, additionalClasses: string) => {

        const allComponents: any = [];
        let dataIndex = 0;
        const that = this;
        source.data.forEach(function (data: any, index: number, array: []) {

            if (_.isEmpty(data)) return;

            const templateElement = that.getRawTemplate(data, dataString + ".data[" + dataIndex + "]", (additionalClasses || ' '));
            // For inner tables alone show the style attribute width
            if (data.class === "table") {
                data.showWidth = true;
                data.isInnerTable = true;
            }
            const componentElement = templateElement;
            allComponents.push(componentElement);
            dataIndex++;
        });
        if (source.mark && source.mark != "") {
            if (source.fontName) {
                const markColor = source.markColor ? { 'color': '#' + source.markColor} : {};
                return <span tabIndex={0} aria-label={source.mark} role="img" style={markColor} className={source.fontName + ' ' + source.fontName + '_' + source.mark} ></span>;
            }
            return <img tabIndex={0} role="img" aria-label={source.mark} alt={source.mark} src={wingdingsForeground} className={'windings winding_' + source.mark} />;
        }

        let docStyle = "";
        if (source['class'] === "divContainer") {
            if (!_.isUndefined(source.format)) {
                docStyle = source.format.class || "";
            }
        }

        return <div className={docStyle} key={shortid.generate()}> {allComponents} </div>;
    }

    /*
    * The function creates the actual HTML for a Caption component.
    */
    public getCaptionTemplate = (source: any, dataString: any, additionalClasses: string) => {

        const allComponents: any = [];
        let dataIndex = 0;
        const that = this;
        source.data.forEach(function (data: any, index: number, array: []) {
            const templateElement = that.getRawTemplate(data, dataString + ".data[" + dataIndex + "]", (additionalClasses || ' '));
            const componentElement = <BracketTemplate source={source} element={templateElement} key={index} />;
            allComponents.push(componentElement);
            dataIndex++;
        });

        return <div key={shortid.generate()}> {allComponents} </div>;
    }

    public getFPBulletTemplate = (source: any, dataString: any, additionalClasses: string) => {

        const allComponents: any = [];

        if (!_.isUndefined(source.headline)) {
            const headlineTemplate = this.getRawTemplate(source.headline, dataString + '.headline', (additionalClasses || ' '));
            allComponents.push(headlineTemplate);
        }

        if (!_.isUndefined(source.content)) {
            const contentTemplate = this.getRawTemplate(source.content, dataString + '.content', (additionalClasses || ' '));
            allComponents.push(contentTemplate);
        }

        let classJSX = '';
        if (source.format && source.format.class) {
            classJSX = source.format.class;
        }

        let styleJSX = {};
        if (source.format && source.format.style) {
            styleJSX = source.format.style;
        }

        return (<div key={shortid.generate()} className={classJSX} style={StyleTransfrom(styleJSX)}>{allComponents}</div>);
    }

    public getTOCLinkTemplate = (source: any) => {
        return <span key={shortid.generate()} id={source.id} />;
    }

    public getDataTableTemplate = (source: any) => {
        if (isBase64Valid(source.text)) {
            return <div dangerouslySetInnerHTML={{ __html: Base64.decode(source.text) }} key={shortid.generate()}></div>;
        }
        return null;
    }

    public render() {
        const template = [];
        template.push(this.getRawTemplate(this.props.sourceM, this.props.dataStringM, this.props.classNameM));
        return (
            <React.Fragment>
                {/*Important!!! Don't use any dangerouslySetInnerHTML in this domTemplate file!!，Because it can't trigger other Component inside it!! */}
                {template}
            </React.Fragment>
        );
    }
}

export default DomTemplate;
